import { render, staticRenderFns } from "./ResourcesView.vue?vue&type=template&id=4024d060&scoped=true&"
import script from "./ResourcesView.vue?vue&type=script&lang=js&"
export * from "./ResourcesView.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesView.vue?vue&type=style&index=0&id=4024d060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024d060",
  null
  
)

export default component.exports